import React from 'react';
import PageWrapper from '../../components/page-wrapper/page-wrapper';
import EventCalendar from '../../components/event-calendar/event-calendar';
import HeadingUnderline from '../../components/heading-underline/heading-underline';

const CalendarPage = () => {
  return (
    <PageWrapper>
      <div className="container-fluid section-padding">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1 className="display-4 text-center text-red section-title mb-4">Event Calendar</h1>
              <HeadingUnderline />
              <div className="row justify-content-center">
                <div className="col-lg-10">
                  <p className="lead text-center mb-4">
                    View all our upcoming events and click on any event to read the full details.
                  </p>
                  <EventCalendar />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default CalendarPage;